import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m5.323 11.386.865 7.98c.148 1.364 1.347 2.347 2.688 2.201l6.25-.677c1.342-.146 2.302-1.362 2.154-2.727l-.96-8.849M17.633 17.562s2.326-2.314 2.385-2.912c.033-.345-.128-1.668-.29-2.996-.12-.938-.95-1.62-1.873-1.52l-1.394.152"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m13.561 10.026 1.446-.157c1.323-.143 2.283-1.36 2.137-2.707-.146-1.348-1.345-2.33-2.668-2.187l-1.794.195c-.146-1.348-1.344-2.33-2.668-2.187l-.122.014c-1.323.143-2.284 1.36-2.137 2.707l.005.053-1.602.174c-1.427.155-2.465 1.47-2.308 2.923.236 2.989 4.128 3.948 6.224 2.806 1.38-.76.71-2.068.327-2.673-.404-.638-1.296-.738-1.722-.118-.56.85 1.367 1.718 3.343.284"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const AlcoholIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
